import React from "react";
import Lottie from "lottie-react";
import { useTheme } from "../providers/ThemeProvider";
import barGraphAnimation from "../assets/lottie/barGraph.json";

const Loading: React.FC<{ className?: string }> = ({ className }) => {
  const { isDark } = useTheme();
  const hasHeight = className?.includes("h-");

  return (
    <div
      className={`flex items-center justify-center ${hasHeight ? "" : "h-screen w-screen"} ${className ?? ""}`}
      style={{
        position: "relative",
        overflow: "hidden",
        background: isDark
          ? "#0a0a0a"
          : "linear-gradient(145deg,#f4f6fb 0%,#eef1f8 60%,#f4f6fb 100%)",
      }}
    >
      {/* Grid pattern */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: isDark
            ? "linear-gradient(rgba(255,255,255,0.025) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.025) 1px,transparent 1px)"
            : "linear-gradient(rgba(0,0,0,0.04) 1px,transparent 1px),linear-gradient(90deg,rgba(0,0,0,0.04) 1px,transparent 1px)",
          backgroundSize: "44px 44px",
        }}
      />


      <div style={{ position: "relative", width: 320, height: 320 }}>
        <Lottie
          animationData={barGraphAnimation}
          loop
          autoplay
          style={{ width: "100%", height: "100%" }}
        />
      </div>
    </div>
  );
};

export default Loading;
